// Acesso ao LIVE (/mirror/live e /language/live) — a decisão em UM lugar.
//
// ─────────────────────────────────────────────────────────────────────────
// POR QUE ISTO EXISTE (tarefas 3f12119e + decisão Rafa 30/08)
// ─────────────────────────────────────────────────────────────────────────
// O LIVE de hoje roda o MESMO pipeline do Espelho (Whisper via mirror-stt +
// mirror-chat + TTS), só com o avatar em busto — nenhuma feature nova liga
// aqui, e a COTA já vale igual: o mirror-stt debita por segundo ANTES de
// gastar (Free 1200s/mês, Premium 2400s) e registra em
// ai_usage_calls/ai_usage_log. Palavras do Rafa: "o free já tem a cota de
// uso então tudo certo, é a mesma coisa que ele estivesse falando com o
// Espelho com voz". Então o Free entra e usa — sem recusa, sem paywall,
// sem selo (o desenho de 24/08 com recusa por áudio foi ABANDONADO).
//
// ─────────────────────────────────────────────────────────────────────────
// 🔴 RELIGADO EM 05/09/2026 (LOTE 3) — o LIVE virou OpenAI Realtime
// ─────────────────────────────────────────────────────────────────────────
// A abertura de 30/08 valia enquanto o LIVE era o pipeline do Espelho e a
// cota do mirror-stt cobria. Agora /mirror/live é WebRTC direto com a
// OpenAI (useMirrorLive → mirror-live-token): Free tem teto 0 em
// voice.live_minutes_per_month e cada segundo é faturado por minuto.
// Ligar o cliente Realtime sem virar esta constante seria a decisão mais
// cara possível neste arquivo.
//
// As TRÊS portas (header do Espelho, pill da Home, modo professor do
// Idiomas) leem só esta constante: com true, o selo PREMIUM da Home e o
// redirect para /pricing voltam sozinhos. O 402 de cota (Premium sem
// minutos) é outra coisa — vem do token, com period_end, e abre o
// PaywallSheet com a copy de renovação.
// Pinado em src/test/liveFreeAccess.test.ts e src/test/mirrorLiveClient.test.tsx.
export const LIVE_REQUIRES_PREMIUM = true;

/**
 * A semântica do gate, PURA para o teste exercitar os dois estados sem
 * flipar a constante: bloqueia quando o live exige Premium E o usuário
 * não é. As portas usam a constante diretamente (com a disciplina de
 * isLoading do useRequirePremium onde há redirect); esta função é a spec.
 */
export function liveGateBlocksFor(
  requiresPremium: boolean,
  isPremium: boolean,
): boolean {
  return requiresPremium && !isPremium;
}
